<template>
  <div
    id="bulk_print_order_invoices_modal"
    class="modal fade"
  >
    <div
      id="bulk-print-area"
      class="modal-dialog modal-full"
      style="max-width: 850px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="rtl-float-left">
            <v-btn
              id="bulk-print-button"
              @click="printInvoices"
              style="height:auto"
              outline
              color="primary"
            >{{ $t('printLogs.printButton') }}</v-btn>
          </div>
          <button
            id="bulk-close-button"
            type="button"
            class="close"
            @click="closeModal('bulk_print_order_invoices_modal')"
          >
            &times;
          </button>
        </div>

        <div class="modal-body">
          <div
            v-for="(invoice, index) in printData"
            :key="invoice.order_invoice_id"
          >
            <order-invoice-document
              :invoiceData="invoice"
              :companyData="companyData"
              :exRate="exRate"
            />

            <div
              v-if="(index + 1) < printData.length"
              style="page-break-after: always"
            >&nbsp;</div>
          </div>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderInvoiceDocument from './OrderInvoiceDocument.vue'

export default {
  components: {
    OrderInvoiceDocument
  },

  props: {
    printData: { default: () => [] },
    companyData: { default: () => ({}) },
    exRate: { default: 1 },
    closeModal: { type: Function, required: true }
  },

  methods: {
    printInvoices() {
      $('#bulk-close-button').hide()
      $('#bulk-print-button').hide()

      $('#bulk-print-area').printMe({ path: this.$_print_stylesheet_paths() })

      $('#bulk-close-button').show()
      $('#bulk-print-button').show()
    }
  }
}
</script>

<style scoped>
.modal {
  text-align: center;
  padding: 0 !important;
  overflow-x: auto;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/orderInvoice/BulkPrintOrderInvoices.vue